import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { BsTrash, BsFillPencilFill } from "react-icons/bs";
import { HIGHLIGHT_TYPE } from "../../configs/constants";
import { getGridLineColor } from '../../helpers/utils'
import { GrView } from "react-icons/gr";
import { BiCloudDownload } from "react-icons/bi";

function isOfferStr (value) {
  switch (value) {
    case HIGHLIGHT_TYPE.blink:
      return "Pisca";
    case HIGHLIGHT_TYPE.club:
      return "Clube";
    case HIGHLIGHT_TYPE.offer:
      return "Oferta";
    default: 
      return "Nenhum";
  }
}

const FolderCard = ({
  productCode,
  productName,
  productValue,
  highlightType,
  originalValue,
  clubValue,
  index,
  onClick,
  onDelete,
  onView,
  onDownload 
}) => (
  <Card style={{ cursor: "pointer", marginBottom: "0px" }} className="card-chart">
    <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
      <Row>
        <Col xs={4} md={2} style={{display: "flex", alignItems: "center"}}>
          {productCode}
        </Col>
        <Col xs={4} md={5} style={{display: "flex", alignItems: "center"}}>
          {productName}
        </Col>       
        <Col md={1} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {isOfferStr(highlightType)}
        </Col>        
        <Col md={2} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {highlightType === HIGHLIGHT_TYPE.offer ? originalValue : highlightType === HIGHLIGHT_TYPE.club ? clubValue : productValue}
        </Col>
        <Col xs={4} md={2} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <BiCloudDownload 
            onClick={onDownload}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Baixar"
            size= {20}
          />
          <GrView
            onClick={onView}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Visualizar"
            size= {20}
          />       
          <BsTrash
            onClick={onDelete}
            title="Deletar"
            size= {20}
            color="#ec250d"
            className="icon-xs-0"
          /> 
          <BsFillPencilFill              
            size= {20}
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Editar"
            onClick={onClick}
            color="#4cd678"
            className="icon-xs"
          />
        </Col>
      </Row> 
    </CardBody>
  </Card>
);

export default FolderCard;
